export enum FLOW_CONTEXT_TYPES {
    requestQuote = 'request_a_quote',
    purchase = 'purchase',
    contact = 'contact',
    convert = 'convert',
    save_expert = 'save_expert',
    join_button = 'join_button',
    no_result_page_brief = 'no_result_page_brief',
    no_result_page_chat = 'no_result_page_chat',
}
